<template>
<div class="chapter">
<div class="inner_page">
<div class="tx21">
<p class="jtp1" id="d41151231"><b> Also by Iain Levison </b></p>
</div>
<div class="tx10">
<p class="jtp1" id="d41151261"><i> A Working Stiff's Manifesto</i></p>
<p class="jtp1" id="d41151262"><i> </i><i>Since the Layoffs </i></p>
<p class="jtp1" id="d41151263"><i> Dog Eats Dog </i></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chap2a_howtorob_9781569477113_epub_part2a.vue?6b537a20